import { Copy, ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";
import { EmptyState } from "../../components/app/EmptyState";
import { Badge } from "../../components/ui/badge";
import { Button } from "../../components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";
import { copyText } from "../../lib/utils";
import { useCurrentCompany, useSession } from "../../services/SessionContext";

export function SharedLinksPage() {
  const { state, disableShareLink } = useSession();
  const company = useCurrentCompany();
  if (!company) return null;
  const links = state.shareLinks.filter((link) => link.companyId === company.companyId);

  return (
    <div className="space-y-6 pb-20 md:pb-0">
      <div>
        <h1 className="text-2xl font-bold text-navy-950">Shared links</h1>
        <p className="mt-1 text-sm text-slate-600">Public, client-safe, and support links created from uploads.</p>
      </div>
      {links.length === 0 ? (
        <EmptyState title="No shared links yet." description="Open an upload and create a public, client-safe, or support link." />
      ) : (
        <Card>
          <CardHeader>
            <CardTitle>All links</CardTitle>
          </CardHeader>
          <CardContent className="space-y-3">
            {links.map((link) => {
              const upload = state.uploads.find((item) => item.uploadId === link.uploadId);
              const path = link.type === "CLIENT_SAFE" ? `/c/${link.shareId}` : link.type === "SUPPORT" ? `/support/${link.shareId}` : `/s/${link.shareId}`;
              const href = `${window.location.origin}${path}`;
              return (
                <div key={link.shareId} className="flex flex-col gap-3 rounded-lg border border-slate-200 p-4 sm:flex-row sm:items-center sm:justify-between">
                  <div>
                    <p className="font-semibold text-navy-900">{upload?.projectName || upload?.originalFileName}</p>
                    <p className="text-sm text-slate-600">{link.type.replace("_", " ")} link</p>
                    <Link className="mt-1 inline-flex items-center gap-1 text-sm text-navy-900 hover:underline" to={path}>
                      Open link <ExternalLink className="h-3.5 w-3.5" aria-hidden />
                    </Link>
                  </div>
                  <div className="flex flex-wrap gap-2">
                    <Badge className={link.isActive ? "bg-field-100 text-field-600 ring-field-600/20" : "bg-slate-100 text-slate-600 ring-slate-200"}>
                      {link.isActive ? "Active" : "Disabled"}
                    </Badge>
                    <Button size="sm" variant="secondary" onClick={() => copyText(href)}>
                      <Copy className="h-4 w-4" aria-hidden /> Copy
                    </Button>
                    {link.isActive ? (
                      <Button size="sm" variant="destructive" onClick={() => disableShareLink(link.shareId)}>
                        Disable
                      </Button>
                    ) : null}
                  </div>
                </div>
              );
            })}
          </CardContent>
        </Card>
      )}
    </div>
  );
}
